export default __webpack_public_path__ + "static/media/dublicate.c857cc07.png";